import { render, staticRenderFns } from "./goodcourse.vue?vue&type=template&id=0c3f7f66&scoped=true&"
import script from "./goodcourse.vue?vue&type=script&lang=js&"
export * from "./goodcourse.vue?vue&type=script&lang=js&"
import style0 from "./goodcourse.vue?vue&type=style&index=0&id=0c3f7f66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f7f66",
  null
  
)

export default component.exports